import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { HeadCell, TableCell, TableCellWithSorting, Typography } from '../../../../ui-kit';
import { Row } from './types';

interface TableHeadCellsProps {
    headCell: HeadCell<Row>;
    index: number;
    markupSort: string | false;
    setMarkupSort(arg: string | false): void;
    foodCostSort: string | false;
    setFoodCostSort(arg: string | false): void;
    netRevenueSort: string | false;
    setNetRevenueSort(arg: string | false): void;
    quantitySort: string | false;
    setQuantitySort(arg: string | false): void;
    revenueSort: string | false;
    setRevenueSort(arg: string | false): void;
}

const TableHeadCells = ({
    headCell,
    index,
    markupSort, setMarkupSort,
    foodCostSort, setFoodCostSort,
    netRevenueSort, setNetRevenueSort,
    quantitySort, setQuantitySort,
    revenueSort, setRevenueSort,
}: TableHeadCellsProps) => {
    const { t } = useTranslation();
    let tableHeadCellContent: React.ReactNode;

    switch (headCell.id) {
        case 'grossRevenue':
            tableHeadCellContent = (
                <TableCellWithSorting
                    align={headCell.align}
                    label={headCell.label}
                    sort={revenueSort}
                    setSort={setRevenueSort}
                />
            );
            break;
        case 'netRevenue':
            tableHeadCellContent = (
                <TableCellWithSorting
                    align={headCell.align}
                    label={headCell.label}
                    sort={netRevenueSort}
                    setSort={setNetRevenueSort}
                />
            );
            break;
        case 'quantity':
            tableHeadCellContent = (
                <TableCellWithSorting
                    align={headCell.align}
                    label={headCell.label}
                    sort={quantitySort}
                    setSort={setQuantitySort}
                />
            );
            break;
        case 'netMargin':
            tableHeadCellContent = (
                <TableCellWithSorting
                    align={headCell.align}
                    label={headCell.label}
                    sort={markupSort}
                    setSort={setMarkupSort}
                />
            );
            break;
        case 'foodCost':
            tableHeadCellContent = (
                <TableCellWithSorting
                    align={headCell.align}
                    label={headCell.label}
                    sort={foodCostSort}
                    setSort={setFoodCostSort}
                />
            );

            break;
        default:
            tableHeadCellContent = (
                <Typography
                    align={headCell.align}
                    uppercase
                    color='textSecondary'
                    variant='caption'
                >
                    {t(...headCell.label)}
                </Typography>
            );
            break;
    }
    return (
        <TableCell
            id={headCell.id as string}
            key={headCell.id as string}
            align={headCell.align}
            isTableHead
            isSticky={index === 0}
            padding='none'
        >
            <Box m={2}>
                {tableHeadCellContent}
            </Box>
        </TableCell>
    );
};

export default TableHeadCells;
